import $ from 'jquery';


$(document).ready(() => {

    const $trigger = $('[data-js-info-trigger]');
    const $target = $('[data-js-info-target]');
    const $close = $('[data-js-info="close"]');
    const $overlay = $('[data-js-info="overlay"]');
    const $body = $('body');

    $trigger.on('click', (e) => {

        $body.addClass('locked');

        $('[data-js-info-target="' + $(e.currentTarget).data('js-info-trigger') + '"]').addClass('is-active');

    });

    $overlay.on('click', () => {
        $target.removeClass('is-active');
        $body.removeClass('locked');
    });

    $close.on('click', () => {
        $target.removeClass('is-active');
        $body.removeClass('locked');
    });
});